import { render, staticRenderFns } from "./veStuYyprojectEdit.vue?vue&type=template&id=78b277ce&scoped=true"
import script from "./veStuYyprojectEdit.vue?vue&type=script&lang=js"
export * from "./veStuYyprojectEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b277ce",
  null
  
)

export default component.exports